import Name from './Name';
import Sum from './Sum';
import Barcode from './Barcode';
import CountPerPack from './CountPerPack'

export const labels = {
  Barcode: 'Azonosító',
  Name: 'Név',
  Sum: 'Mennyiség',
  CountPerPack: 'Db / kiszerelés'
};

export const allColumns = [{
  value: 'Barcode',
  fixed: true
}, {
  value: 'Name',
}, {
  value: 'Sum',
}, {
  value: 'CountPerPack',
}];

export const defaultColumns = [
  {
    value: 'Barcode',
    fixed: true,
  },
  {
    value: 'Name',
  },{
    value: 'Sum',
  }, {
    value: 'CountPerPack',
  }
];

export const defaultSort = {
  prop: Name.propName,
  order: 'descending'
};

export default {
  Name,
  Barcode,
  Sum,
  CountPerPack
};
